/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BonNumberUpdateModel } from '../models/BonNumberUpdateModel';
import type { BookingSummaryModel } from '../models/BookingSummaryModel';
import type { BranchType } from '../models/BranchType';
import type { CaseSaveModel } from '../models/CaseSaveModel';
import type { CustomerData } from '../models/CustomerData';
import type { NoteModel } from '../models/NoteModel';
import type { NoteSaveModel } from '../models/NoteSaveModel';
import type { ServiceBalanceModel } from '../models/ServiceBalanceModel';
import type { SoLabourWithLoadStatusModel } from '../models/SoLabourWithLoadStatusModel';
import type { SoOperData } from '../models/SoOperData';
import type { TechnicianJobDetailedModel } from '../models/TechnicianJobDetailedModel';
import type { VideoLogDto } from '../models/VideoLogDto';
import type { WipAppointmentPreparationEditModel } from '../models/WipAppointmentPreparationEditModel';
import type { WipAppointmentPreparationModel } from '../models/WipAppointmentPreparationModel';
import type { WIPDetailedLaboursAndPartsModel } from '../models/WIPDetailedLaboursAndPartsModel';
import type { WIPDetailedModel } from '../models/WIPDetailedModel';
import type { WipPreparationNoteSaveModel } from '../models/WipPreparationNoteSaveModel';
import type { WipStatusSubmitModel } from '../models/WipStatusSubmitModel';
import type { WorkshopDetailedModel } from '../models/WorkshopDetailedModel';
import type { WorkshopFilterType } from '../models/WorkshopFilterType';
import type { WorkshopGlobalFilterType } from '../models/WorkshopGlobalFilterType';
import type { WorkshopModelPagedListData } from '../models/WorkshopModelPagedListData';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class WorkshopService {

  /**
   * @param type
 *
 * 0 = DueIn
 *
 * 1 = CheckedInToday
 *
 * 2 = WorkInProgress
 *
 * 3 = AwaitingCheckedOut
 *
 * 4 = AwaitingOnSite
 *
 * 5 = CompletedNotInvoiced
 *
 * 6 = Invoiced
 *
 * 7 = InvoicedNotCollected
   * @param globalType
 *
 * 0 = External
 *
 * 1 = SalesPreparation
 *
 * 2 = All
   * @param dueInFrom 
   * @param dueInTo 
   * @param dueOutFrom 
   * @param dueOutTo 
   * @param branch
 *
 * 1 = Slough
 *
 * 2 = HighWycombe
 *
 * 3 = Maidenhead
 *
 * 4 = Watford
 *
 * 6 = HemelHempstead
 *
 * 7 = Romford
   * @param operatorBranchId 
   * @param operatorNumber 
   * @param regNo 
   * @param wipNo 
   * @param partStatus 
   * @param paggingPage 
   * @param paggingPageSize 
   * @returns WorkshopModelPagedListData Success
   * @throws ApiError
   */
  public static getWorkshop(
type?: WorkshopFilterType,
globalType?: WorkshopGlobalFilterType,
dueInFrom?: string,
dueInTo?: string,
dueOutFrom?: string,
dueOutTo?: string,
branch?: BranchType,
operatorBranchId?: number,
operatorNumber?: number,
regNo?: string,
wipNo?: number,
partStatus?: string,
paggingPage?: number,
paggingPageSize?: number,
): CancelablePromise<WorkshopModelPagedListData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop',
      query: {
        'Type': type,
        'GlobalType': globalType,
        'DueInFrom': dueInFrom,
        'DueInTo': dueInTo,
        'DueOutFrom': dueOutFrom,
        'DueOutTo': dueOutTo,
        'Branch': branch,
        'Operator.BranchId': operatorBranchId,
        'Operator.Number': operatorNumber,
        'RegNo': regNo,
        'WipNo': wipNo,
        'PartStatus': partStatus,
        'Pagging.Page': paggingPage,
        'Pagging.PageSize': paggingPageSize,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param globalType
 *
 * 0 = External
 *
 * 1 = SalesPreparation
 *
 * 2 = All
   * @param dueInFrom 
   * @param dueInTo 
   * @param dueOutFrom 
   * @param dueOutTo 
   * @param branch
 *
 * 1 = Slough
 *
 * 2 = HighWycombe
 *
 * 3 = Maidenhead
 *
 * 4 = Watford
 *
 * 6 = HemelHempstead
 *
 * 7 = Romford
   * @param operatorBranchId 
   * @param operatorNumber 
   * @param regNo 
   * @param wipNo 
   * @param partStatus 
   * @param paggingPage 
   * @param paggingPageSize 
   * @returns WorkshopModelPagedListData Success
   * @throws ApiError
   */
  public static getWorkshopCards(
globalType?: WorkshopGlobalFilterType,
dueInFrom?: string,
dueInTo?: string,
dueOutFrom?: string,
dueOutTo?: string,
branch?: BranchType,
operatorBranchId?: number,
operatorNumber?: number,
regNo?: string,
wipNo?: number,
partStatus?: string,
paggingPage?: number,
paggingPageSize?: number,
): CancelablePromise<WorkshopModelPagedListData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop/cards',
      query: {
        'GlobalType': globalType,
        'DueInFrom': dueInFrom,
        'DueInTo': dueInTo,
        'DueOutFrom': dueOutFrom,
        'DueOutTo': dueOutTo,
        'Branch': branch,
        'Operator.BranchId': operatorBranchId,
        'Operator.Number': operatorNumber,
        'RegNo': regNo,
        'WipNo': wipNo,
        'PartStatus': partStatus,
        'Pagging.Page': paggingPage,
        'Pagging.PageSize': paggingPageSize,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param type
 *
 * 0 = DueIn
 *
 * 1 = CheckedInToday
 *
 * 2 = WorkInProgress
 *
 * 3 = AwaitingCheckedOut
 *
 * 4 = AwaitingOnSite
 *
 * 5 = CompletedNotInvoiced
 *
 * 6 = Invoiced
 *
 * 7 = InvoicedNotCollected
   * @param globalType
 *
 * 0 = External
 *
 * 1 = SalesPreparation
 *
 * 2 = All
   * @param dueInFrom 
   * @param dueInTo 
   * @param dueOutFrom 
   * @param dueOutTo 
   * @param branch
 *
 * 1 = Slough
 *
 * 2 = HighWycombe
 *
 * 3 = Maidenhead
 *
 * 4 = Watford
 *
 * 6 = HemelHempstead
 *
 * 7 = Romford
   * @param operatorBranchId 
   * @param operatorNumber 
   * @param regNo 
   * @param wipNo 
   * @param partStatus 
   * @param paggingPage 
   * @param paggingPageSize 
   * @returns SoOperData Success
   * @throws ApiError
   */
  public static getWorkshopOperators(
type?: WorkshopFilterType,
globalType?: WorkshopGlobalFilterType,
dueInFrom?: string,
dueInTo?: string,
dueOutFrom?: string,
dueOutTo?: string,
branch?: BranchType,
operatorBranchId?: number,
operatorNumber?: number,
regNo?: string,
wipNo?: number,
partStatus?: string,
paggingPage?: number,
paggingPageSize?: number,
): CancelablePromise<Array<SoOperData>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop/operators',
      query: {
        'Type': type,
        'GlobalType': globalType,
        'DueInFrom': dueInFrom,
        'DueInTo': dueInTo,
        'DueOutFrom': dueOutFrom,
        'DueOutTo': dueOutTo,
        'Branch': branch,
        'Operator.BranchId': operatorBranchId,
        'Operator.Number': operatorNumber,
        'RegNo': regNo,
        'WipNo': wipNo,
        'PartStatus': partStatus,
        'Pagging.Page': paggingPage,
        'Pagging.PageSize': paggingPageSize,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param wipNo 
   * @returns BookingSummaryModel Success
   * @throws ApiError
   */
  public static getWorkshopBookingSummary(
wipNo?: number,
): CancelablePromise<BookingSummaryModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop/booking-summary',
      query: {
        'wipNo': wipNo,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param wipNo 
   * @param branchId 
   * @returns any Success
   * @throws ApiError
   */
  public static getWorkshopVhcVideo(
wipNo?: number,
branchId?: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop/vhc-video',
      query: {
        'wipNo': wipNo,
        'branchId': branchId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param soHeaderId 
   * @returns any Success
   * @throws ApiError
   */
  public static getWorkshopClocking(
soHeaderId?: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop/clocking',
      query: {
        'soHeaderId': soHeaderId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param soHeaderId 
   * @returns any Success
   * @throws ApiError
   */
  public static getWorkshopQualityTestDrive(
soHeaderId?: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop/quality-test-drive',
      query: {
        'soHeaderId': soHeaderId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param regno 
   * @param email 
   * @returns ServiceBalanceModel Success
   * @throws ApiError
   */
  public static getWorkshopAdvanceBalance(
regno?: string,
email?: string,
): CancelablePromise<ServiceBalanceModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop/advance-balance',
      query: {
        'regno': regno,
        'email': email,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @returns WorkshopDetailedModel Success
   * @throws ApiError
   */
  public static getWorkshop1(
id: number,
): CancelablePromise<WorkshopDetailedModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns number Success
   * @throws ApiError
   */
  public static postWorkshopWipAppointment(
requestBody?: WipAppointmentPreparationModel,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/workshop/wip-appointment',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns number Success
   * @throws ApiError
   */
  public static putWorkshopWipAppointment(
id: number,
requestBody?: WipAppointmentPreparationEditModel,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/workshop/wip-appointment/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns number Success
   * @throws ApiError
   */
  public static postWorkshopWipStatus(
id: number,
requestBody?: WipStatusSubmitModel,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/workshop/wip-status/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param soHeaderId 
   * @returns SoLabourWithLoadStatusModel Success
   * @throws ApiError
   */
  public static getWorkshopWipLabours(
soHeaderId?: number,
): CancelablePromise<Array<SoLabourWithLoadStatusModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop/wip-labours',
      query: {
        'soHeaderId': soHeaderId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param soHeaderId 
   * @param isFilterStatus 
   * @returns any Success
   * @throws ApiError
   */
  public static getWorkshopWipParts(
soHeaderId?: number,
isFilterStatus?: boolean,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop/wip-parts',
      query: {
        'soHeaderId': soHeaderId,
        'isFilterStatus': isFilterStatus,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public static getWorkshopWipPartsStatuses(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop/wip-parts-statuses',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param soHeaderId 
   * @returns any Success
   * @throws ApiError
   */
  public static getWorkshopWipOrders(
soHeaderId?: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop/wip-orders',
      query: {
        'soHeaderId': soHeaderId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param soHeaderId 
   * @returns WIPDetailedModel Success
   * @throws ApiError
   */
  public static getWorkshopWipDetails(
soHeaderId?: number,
): CancelablePromise<WIPDetailedModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop/wip-details',
      query: {
        'soHeaderId': soHeaderId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param soHeaderId 
   * @returns WIPDetailedLaboursAndPartsModel Success
   * @throws ApiError
   */
  public static getWorkshopWipDetailsLaboursAndParts(
soHeaderId?: number,
): CancelablePromise<Array<WIPDetailedLaboursAndPartsModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop/wip-details-labours-and-parts',
      query: {
        'soHeaderId': soHeaderId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param soHeaderId 
   * @returns any Success
   * @throws ApiError
   */
  public static getWorkshopCheckIn(
soHeaderId?: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop/check-in',
      query: {
        'soHeaderId': soHeaderId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postWorkshopNotes(
requestBody?: NoteSaveModel,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/workshop/notes',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param soHeaderId 
   * @returns NoteModel Success
   * @throws ApiError
   */
  public static getWorkshopNotes(
soHeaderId?: number,
): CancelablePromise<NoteModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop/notes',
      query: {
        'soHeaderId': soHeaderId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postWorkshopWipPrepNotes(
id: number,
requestBody?: WipPreparationNoteSaveModel,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/workshop/wip-prep/{id}/notes',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postWorkshopCases(
requestBody?: CaseSaveModel,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/workshop/cases',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param email 
   * @param regno 
   * @param soHeaderId 
   * @returns any Success
   * @throws ApiError
   */
  public static getWorkshopVauchers(
email?: string,
regno?: string,
soHeaderId?: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop/vauchers',
      query: {
        'email': email,
        'regno': regno,
        'soHeaderId': soHeaderId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static putWorkshopBon(
id: number,
requestBody?: BonNumberUpdateModel,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/workshop/bon/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param soHeaderId 
   * @returns TechnicianJobDetailedModel Success
   * @throws ApiError
   */
  public static getWorkshopTechJob(
id?: number,
soHeaderId?: number,
): CancelablePromise<TechnicianJobDetailedModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop/tech-job',
      query: {
        'id': id,
        'soHeaderId': soHeaderId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns CustomerData Success
   * @throws ApiError
   */
  public static getWorkshopCdkCustomer(
id: number,
): CancelablePromise<CustomerData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop/{id}/cdk-customer',
      path: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @param cdkCustomerId 
   * @returns any Created
   * @throws ApiError
   */
  public static postWorkshopCdkCustomer(
id: number,
cdkCustomerId?: string,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/workshop/{id}/cdk-customer',
      path: {
        'id': id,
      },
      query: {
        'cdkCustomerId': cdkCustomerId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @param isSms 
   * @returns any Success
   * @throws ApiError
   */
  public static postWorkshopSendReadyForCollection(
id: number,
isSms?: boolean,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/workshop/{id}/send-ready-for-collection',
      path: {
        'id': id,
      },
      query: {
        'isSms': isSms,
      },
    });
  }

  /**
   * @param soHeaderId 
   * @returns VideoLogDto Success
   * @throws ApiError
   */
  public static getWorkshopVideo(
soHeaderId: number,
): CancelablePromise<VideoLogDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop/{soHeaderId}/video',
      path: {
        'soHeaderId': soHeaderId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

}
